export const orderNumber = 'order_number';
export const webOrderNumber = 'order_id';
export const webOrderToken = 'order_token';
